<template>
  <button class="switcher" @click="handleClick">
    <transition
      name="fade-up"
      @after-enter="handleTransitionEnd"
      @after-leave="handleTransitionEnd"
    >
      <span v-if="!isAnimating" class="switcher__inner">
        <span>{{ active }}</span>
        <span class="switcher__divider">→</span>
        <span>{{ inactive }}</span>
      </span>
    </transition>
  </button>
</template>

<script>
export default {
  props: {
    active: {
      type: String,
      default: ''
    },
    inactive: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isAnimating: false
    }
  },
  watch: {
    active () {
      this.isAnimating = false
    }
  },
  methods: {
    handleClick () {
      if (this.isAnimating) return
      this.isAnimating = true
    },
    handleTransitionEnd () {
      if (!this.isAnimating) return
      this.$emit('toggle')
    }
  }
}
</script>

<style lang="scss" scoped>
  .switcher {
    @include reset-button;
    color: inherit;
    font-weight: inherit;
    transition: opacity $base-transition;

    &__inner {
      display: inline-block;
    }

    &:focus {
      opacity: .8;
    }
  }

  // Custom transitions
  .fade-up-enter-active,
  .fade-up-leave-active {
    transition: opacity .3s,
                transform .3s;
  }

  .fade-up-enter {
    opacity: 0;
    transform: translate3d(0, 0.4em, 0);
  }

  .fade-up-leave-to {
    opacity: 0;
    transform: translate3d(0, -0.4em, 0);
  }
</style>



// WEBPACK FOOTER //
// src/containers/Navigation/Switcher.vue